import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../hooks/auth.provider";
import { DownloadItemType } from "../../types/DownloadItemType";
import { isDownloadVersionType } from "../../utilities/isDownloadVersionType";

type ItemRowProps = {
  data: DownloadItemType;
  onDelete: () => void;
  className?: string;
};

export const ItemRow = ({ data, onDelete, className = "" }: ItemRowProps) => {
  const { isAuthenticated } = useAuth();

  const baseClassname = "item-row";

  return (
    <div className={`${baseClassname} ${className}`}>
      <div className={`${baseClassname}__links-container`}>
        <a
          className={`${baseClassname}__link`}
          href={String(data.manifest_location || data.file_location)}
        >
          {data.display_name || data.version_number}
          {isDownloadVersionType(data) ? `(${data.build_number})` : <></>}
        </a>

        {data.manifest_location !== null ? (
          <a
            className={`${baseClassname}__link`}
            href={String(data.file_location)}
          >
            download .ipa file.
          </a>
        ) : (
          <></>
        )}
      </div>

      {isAuthenticated && (
        <button className={`${baseClassname}__delete`} onClick={onDelete}>
          <FontAwesomeIcon
            className={`${baseClassname}__delete-icon`}
            icon={faTrash}
          />
        </button>
      )}
    </div>
  );
};
